import { AlertTriangle, CheckCircle2, ShieldAlert } from "lucide-react";
import { productName } from "@/lib/tank";

// Safety review badges on a logged drop.
export function DropFlags({ drop, t }) {
  const over = drop.over90 || drop.finalPct > 90.0001;
  if (!over && !drop.productMismatch) return null;
  return (
    <div className="drop-flags" data-testid={`drop-flags-${drop.id}`}>
      {over && <span className="flag flag-red" data-testid={`drop-over90-${drop.id}`}><AlertTriangle size={14} />{t("OVER 90%")} · {drop.finalPct.toFixed(1)}%</span>}
      {over && (drop.restickConfirmed
        ? <span className="flag flag-ok" data-testid={`drop-restick-${drop.id}`}><CheckCircle2 size={14} />{t("Re-sticked and checked console")}</span>
        : <span className="flag flag-amber" data-testid={`drop-restick-${drop.id}`}>{t("Re-stick not confirmed")}</span>)}
      {drop.productMismatch && <span className="flag flag-red" data-testid={`drop-mismatch-${drop.id}`}><ShieldAlert size={14} />{t("WRONG PRODUCT")}: {t(productName(drop.product))} → {t("tank")} {t(productName(drop.expectedProduct))}{drop.productConfirmed ? ` · ${t("driver confirmed")}` : ""}</span>}
    </div>
  );
}
